
import { Component, ElementRef, OnInit } from '@angular/core';
import { PageBase, T4SettingsPage, T4SettingsService, ControlType, T4Setting } from 't4core';

@Component({
  styleUrls: ['./settings.css'],
  selector: 'settings',
  templateUrl: './settings.component.html',
})
export class SettingsComponent extends PageBase implements OnInit {
    public pages: T4SettingsPage[] = [];
    public Controls = ControlType;

    constructor(el: ElementRef, private svcSettings: T4SettingsService) {
      super(el, "Settings");

    }

    async ngOnInit() { 
        this.GetPages();
    }

    public async GetPages() {
          var token = this.UI.beginLoading("T4.Settings.Settings.msgLoading", "Loading settings", null);
          this.pages = await this.svcSettings.GetSettingsPages();
          this.UI.loaderCompleted(token);
    }

    public async saveOne(setting: T4Setting) {
        if (setting.Value == setting.OriginalValue) return;

        var ret = await this.svcSettings.SaveLocationSetting(setting);
        setting.Value = ret.Value;
        setting.EffectiveValue = ret.EffectiveValue;
        setting.OriginalValue = ret.OriginalValue;
        this.UI.snackBar("Saved");
    }

    public async saveValue(setting: T4Setting, value: any) {
        setting.Value = value;
        await this.saveOne(setting);
    }

    public async editJson(setting: T4Setting) {
        var ret = await this.UI.openDialog<any>("T4.Common.JsonDialog", { data: { json: setting.Value, disableClose: true } });
          if (ret !== false) {
            setting.Value = ret;
            this.saveOne(setting);
          }
    }
}
